import { render } from "./ModalSocialite.vue?vue&type=template&id=3635d066&scoped=true"
import script from "./ModalSocialite.vue?vue&type=script&lang=js"
export * from "./ModalSocialite.vue?vue&type=script&lang=js"

import "./ModalSocialite.vue?vue&type=style&index=0&id=3635d066&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3635d066"]])

export default __exports__